import React from 'react';
import SuperAdminLayout from '../../layout/SuperAdminLayout';
const SuperadminAccount = () => {
    return (
        <SuperAdminLayout>
            SuperadminAccount
        </SuperAdminLayout>
    )
}

export default SuperadminAccount;